import { Auth0UserProfile } from '@interface/auth0.interface';
import { createAction, props } from '@ngrx/store';

export const setAuth = createAction(
  '[Auth API] Set Auth State',
  props<{ loggedIn: boolean; userProfile: Auth0UserProfile }>()
);
